import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/cn";

/**
 * Workshop: Sidebar frame list item — icon, title, accent bar, and status dot.
 */

interface SidebarFrameItemProps {
  title: string;
  icon: LucideIcon;
  active?: boolean;
  statusColor?: string;
  hideAccent?: boolean;
  onClick?: () => void;
  className?: string;
  "data-testid"?: string;
}

export function SidebarFrameItem({
  title,
  icon: Icon,
  active = false,
  statusColor = "bg-accent",
  hideAccent = false,
  onClick,
  className,
  "data-testid": testId,
}: SidebarFrameItemProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "flex h-8 w-full items-center gap-2 px-4 transition-colors",
        active
          ? "bg-glass-stroke-light"
          : "hover:bg-glass-stroke-subtle",
        className,
      )}
      data-testid={testId}
    >
      {!hideAccent && (
        <span
          className="h-3 w-0.5 shrink-0 rounded-[1px] bg-accent"
          aria-hidden="true"
        />
      )}
      <Icon className="h-3 w-3 shrink-0 text-muted" aria-hidden="true" />
      <span className="flex-1 truncate text-left text-[11px] text-secondary">
        {title}
      </span>
      <span
        className={cn("h-1.5 w-1.5 shrink-0 rounded-full", statusColor)}
        aria-hidden="true"
      />
    </button>
  );
}

export type { SidebarFrameItemProps };
